class Controller {
  constructor($injector, $stateParams, Sections) {
    "ngInject";
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.noteEvent = this.Events.getUpdateEvent("CorporateInvoiceItemNote");
    this.corporateResource = this.$injector.get("Corporate");
    this.CorporateTransforms = $injector.get("CorporateTransforms");
    this.corporateInvoiceItemTransforms = this.$injector.get(
      "CorporateInvoiceItemTransforms"
    );
    this.sections = Sections.customersSections;
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onAddNote = (options) => {
      const note = options.comment.value;
      this.corporateResource
        .addNote(this.$stateParams.id, { note })
        .$promise.then(
          (response) => {
            this.corporateInvoiceItem = this.corporateInvoiceItemTransforms.justify(
              response
            );
            this.Events.emit(showNotificationEvent, {
              message: "Your note added successfully",
            });
          },
          (response) => this.Events.emit(errorEvent, response.data)
        );
    };

    this.Events.on(this.noteEvent, onAddNote);

    this.corporateResource
      .getInvoiceItem(this.$stateParams.id)
      .$promise.then((response) => {
        this.corporateInvoiceItem = this.corporateInvoiceItemTransforms.justify(
          response
        );
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoiceItem/corporateInvoiceItem.controller.js